<template>
  <div class="page">
    <Navbar isBack="true" title="被盗找回"/>
    <div class="page_box">
      <div class="vip_level_nav">被盗找回</div>
      <div class="vip_level_dec">
        玩家在Muu账号VIP等级达到V6及以上的时候，享有被盗找回的会员权益，具体VIP等级对应的被盗找回权益如下：
      </div>
      <div class="vip_level_table">
        <div class="vip_level_tr">
          <div class="vip_level_tb">VIP等级</div>
          <div class="vip_level_tb">找回次数</div>
        </div>
        <div class="vip_level_tr">
          <div class="vip_level_tb">0~5</div>
          <div class="vip_level_tb">无</div>
        </div>
        <div class="vip_level_tr">
          <div class="vip_level_tb">6-10</div>
          <div class="vip_level_tb">1次/半年</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data(){
    return {
      
    }
  },
  methods: {
    
  }
}
</script>
<style scoped lang="scss">
$vip-color: #c37c00;
.page_box {
  padding: 0 0.22rem 1rem 0.22rem;
}
.vip_level_nav {
  margin: 0.4rem 0 0.1rem 0;
  padding: 0 0.3rem;
  line-height: 0.4rem;
  border: 1px solid $vip-color;
  color: $vip-color;
  border-radius: 1rem;
}
.vip_level_img {
  margin: 0.3rem 0;
}
.vip_level_dec {
  line-height: 0.4rem;
  font-size: 0.23rem;
}
.vip_level_table {
  margin-top: 0.3rem;
  width: 100%;
  border-left: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}
.vip_level_tr {
  display: flex;
}
.vip_level_tr:nth-child(1) {
  background-color: #fde2b0;
}
.vip_level_tr:nth-child(1) .vip_level_tb {
  height: 0.9rem;
  color: $vip-color;
}
.vip_level_tb {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 0.6rem;
  font-size: 0.23rem;
  border-top: 1px solid #ddd;
  border-right: 1px solid #ddd;
}
</style>